<template>
  <div class="case-prize">
    <div>
      <el-button icon="el-icon-back" @click="$router.back()">返回</el-button>
      <el-button size="small" type="primary" @click="handleAdd"
        >添加盒子奖品2</el-button
      >
    </div>
    <div>
      <el-table :data="dataList" v-loading="loading">
        <el-table-column prop="id" label="奖品ID" width="100px">
          <template slot-scope="{ row }">{{ row.prize.id }}</template>
        </el-table-column>
        <el-table-column prop="name" label="奖品名称">
          <template slot-scope="{ row }">{{ row.prize.name }}</template>
        </el-table-column>
        <el-table-column prop="second_name" label="第二名称">
          <template slot-scope="{ row }">{{ row.prize.second_name }}</template>
        </el-table-column>
        <el-table-column label="图片">
          <template slot-scope="{ row }">
            <img class="table-image" :src="row.prize.image" alt />
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格">
          <template slot-scope="{ row }">{{ row.prize.price }}</template>
        </el-table-column>
        <el-table-column prop="category_id" label="所属分类">
          <template slot-scope="{ row }">{{
            getCategoryName(row.prize.category_id)
          }}</template>
        </el-table-column>
        <el-table-column prop="status" label="等级">
          <template slot-scope="{ row }">
            <span :style="`color: ${getRankColor(row.prize.rank)};`">{{
              getRank(row.prize.rank)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="weight" label="权重"></el-table-column>
        <el-table-column
          prop="display_probability"
          label="显示概率"
        ></el-table-column>
        <el-table-column
          prop="true_probability"
          label="真实概率"
        ></el-table-column>
        <el-table-column prop="number" label="数量">
          <template slot-scope="{ row }">
            <span
              :style="
                `color: ${
                  row.prize.number  < 20
                    ? '#c00'
                    : '#333'
                };`
              "
              >{{ row.prize.number }}</span
            >
          </template>
        </el-table-column>
				<el-table-column prop="delivery_type" label="发货方式">
					<template slot-scope="{ row }">
						<span v-if="row.prize.delivery_type === 1">手动发货</span>
						<span v-if="row.prize.delivery_type === 2">机器人发货</span>
						<span v-if="row.prize.delivery_type === 3">扎比特发货(人工手动)</span>
						<span v-if="row.prize.delivery_type === 4">扎比特发货(自动脚本)</span>
					</template>
				</el-table-column>
        <el-table-column label="操作" width="240px">
          <template slot-scope="{ row }">
            <el-button type="primary" plain @click="handleEdit(row)"
              >编辑</el-button
            >
            <el-button
              type="primary"
              @click="
                handleChangeNumber(
                  row.prize.id,
                  row.prize.number
                )
              "
              >修改数量</el-button
            >
            <el-button type="danger" @click="handleDelete(row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :visible.sync="visible"
      :title="isEdit ? '编辑奖品' : '添加奖品'"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form :model="formData" label-width="100px" :rules="rules" ref="form">
        <el-form-item prop="prize_id" label="奖品">
          <div v-if="selectedPrize" class="prize-item">
            <img :src="selectedPrize.image" alt />
            <p>
              <span>{{ selectedPrize.name }}</span>
            </p>
            <p>
              <span>{{ selectedPrize.second_name }}</span>
            </p>
            <p>
              <span :style="`color: ${getRankColor(selectedPrize.rank)};`">{{
                getRank(selectedPrize.rank)
              }}</span>
              <span class="price">${{ selectedPrize.price }}</span>
            </p>
          </div>
          <div v-else class="add-prize" @click="visiblePrize = true">
            <i class="el-icon-plus"></i>
            <p>选择奖品</p>
          </div>
        </el-form-item>
        <el-form-item prop="display_probability" label="显示概率">
          <el-input
            v-model="formData.display_probability"
            placeholder="显示给用户的概率(0-100)"
          ></el-input>
        </el-form-item>
        <el-form-item prop="true_probability" label="真实概率">
          <el-input
            v-model="formData.true_probability"
            placeholder="抽奖算法真实的概率(0-100)"
          ></el-input>
        </el-form-item>
        <el-form-item prop="box_weight" label="盒子权重">
          <el-input
            v-model="formData.box_weight"
            placeholder="盒子权重"
          ></el-input>
        </el-form-item>
        <el-form-item prop="weight" label="排序">
          <el-input v-model="formData.weight" placeholder="排序"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submit"
          :loading="buttonLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="visiblePrize"
      title="奖品列表"
      :close-on-click-modal="false"
      width="930px"
    >
      <div class="prize-list-wrap" v-loading="loadingPrize">
        <ul class="prize-list">
          <li class="prize-item" v-for="item in prizeList" :key="item.id">
            <i
              class="el-icon-plus"
              title="添加"
              @click="handleAddPrize(item)"
            ></i>
            <img :src="item.image" alt />
            <p>
              <span>{{ item.name }}</span>
            </p>
            <p>
              <span>{{ item.second_name }}</span>
            </p>
            <p>
              <span :style="`color: ${getRankColor(item.rank)};`">{{
                getRank(item.rank)
              }}</span>
              <span class="price">${{ item.price }}</span>
            </p>
            <p style="text-align: center;">
              数量：{{ item.number - item.sold_number }}
            </p>
          </li>
        </ul>
      </div>
      <el-pagination
        background
        :page-size="prizeListMeta.per_page || 15"
        :total="prizeListMeta.total || 0"
        :current-page="prizePage"
        @current-change="handlePrizePageChange"
        v-if="prizeListMeta && prizeListMeta.total > prizeListMeta.per_page"
      ></el-pagination>
    </el-dialog>
    <el-pagination
      background
      :page-size="dataMeta.per_page || 15"
      :total="dataMeta.total || 0"
      :current-page="page"
      @current-change="handlePageChange"
      v-if="dataMeta && dataMeta.total > dataMeta.per_page"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { server, postData, delData, patchData, getData } from '../../http'
import { getCookie } from '../../utils/cookie'
import ranks from '@/utils/ranks'

export default {
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    this.ranks = ranks
    return {
      formData: {
        prize_id: undefined,
        display_probability: '',
        true_probability: '',
        weight: undefined,
        box_weight: ''
      },
      rules: {
        prize_id: [{ required: true, message: '请选择要添加到奖品' }],
        display_probability: [{ required: true, message: '请输入显示概率' }],
        true_probability: [{ required: true, message: '请输入真实概率' }]
      },
      page: 1,
      prizePage: 1,
      editInfo: undefined,
      loading: false,
      visible: false,
      buttonLoading: false,
      isEdit: false,
      dataList: undefined,
      dataMeta: {},
      visiblePrize: false,
      loadingPrize: false,
      prizeList: undefined,
      prizeListMeta: {},
      selectedPrize: undefined
    }
  },
  computed: {
    ...mapState({
      categories: state => state.data.categories
    }),
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}file`
    },
    cid() {
      return this.$route.query.cid
    }
  },
  watch: {
    visible(val) {
      if (this.editInfo) {
        const { display_probability, true_probability, weight, box_weight } = this.editInfo
        this.formData = {
          ...this.formData,
          true_probability,
          display_probability,
          weight,
          box_weight
        }
      } else {
        if (this.$refs['form']) {
          this.$refs['form'].resetFields()
          this.formData = {
            prize_id: undefined,
            display_probability: '',
            true_probability: '',
            weight: undefined,
            box_weight: undefined
          }
          this.selectedPrize = undefined
        }
      }
    }
  },
  methods: {
    ...mapActions(['getCategories']),
    getRank(rank) {
      for (let item of this.ranks) {
        if (item.level === rank) {
          return item.text
        }
      }
    },
    getRankColor(rank) {
      for (let item of this.ranks) {
        if (item.level === rank) {
          return item.color
        }
      }
    },
    getCategoryName(id) {
      if (this.categories) {
        for (let item of this.categories) {
          if (item.id === id) {
            return item.name
          }
        }
      } else {
        return ''
      }
    },
    getData() {
      this.loading = true
      getData(`new_box_prize/${this.id}`, { page: this.page })
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res.meta
        })
        .finally(() => {
          this.loading = false
        })
    },
    getPrize() {
      if (!this.cid) {
        return
      }
      this.loadingPrize = true
      getData(`prize`, { category_id: this.cid, page: this.prizePage })
        .then(res => {
          this.prizeList = res.data
          this.prizeListMeta = res.meta
        })
        .finally(() => {
          this.loadingPrize = false
        })
    },
    handleAdd() {
      this.isEdit = false
      this.editInfo = undefined
      this.visible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.editInfo = row
      this.visible = true
      this.selectedPrize = row.prize
      this.formData.prize_id = row.prize.id
    },
    handleAddPrize(row) {
      this.formData.prize_id = row.id
      this.selectedPrize = row
      this.visiblePrize = false
    },
    handleRemovePrize() {
      this.formData.prize_id = undefined
      this.selectedPrize = undefined
    },
    handlePageChange(page) {
      this.page = page
      this.getData()
    },
    handlePrizePageChange(page) {
      this.prizePage = page
      this.getPrize()
    },
    handleDelete(id) {
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delData(`box_prize/${id}`).then(res => {
          this.$message.success('删除成功')
          this.getData()
        })
      })
    },
    handleChangeNumber(id, number) {
      this.$prompt('', '修改奖品数量', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        // inputPlaceholder: '正值增加，负值减少',
        customClass: 'change-prize-number',
        closeOnClickModal: false,
        inputPattern: /^(\-?)\d+(\.\d+)?$/,
        inputErrorMessage: '请输入数字'
      }).then(({ value }) => {
        if (parseInt(number) + parseInt(value) < 0) {
          this.$message.error('奖品数量不能为负')
          return
        }
        patchData(`prize/${id}`, {
          number: value
        }).then(res => {
          this.$message.success('修改成功')
          this.getData()
        })
      })
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.buttonLoading = true
          if (!this.editInfo) {
            postData(`box_prize`, {
              ...this.formData,
              box_id: this.id
            })
              .then(res => {
                this.buttonLoading = false
                this.visible = false
                this.$message.success('添加成功')
                this.getData()
              })
              .finally(() => {
                this.buttonLoading = false
              })
          } else {
            patchData(`new_box_prize/${this.editInfo.id}`, {
              display_probability: this.formData.display_probability,
              true_probability: this.formData.true_probability,
              weight: this.formData.weight,
              box_weight: this.formData.box_weight
            })
              .then(res => {
                this.buttonLoading = false
                this.visible = false
                this.$message.success('编辑成功')
                this.getData()
              })
              .finally(() => {
                this.buttonLoading = false
              })
          }
        }
      })
    }
  },
  created() {
    this.getData()
    this.getPrize()
    !this.categories && this.getCategories()
  }
}
</script>
